import { OnboardingProgressDotsProps } from './OnboardingProgressDots.types'
import './OnboardingProgressDots.scss'

/**
 * OnboardingProgressDots Component
 *
 * Displays progress dots for the onboarding carousel.
 * Active dots are larger (8px) and themed with specific colors.
 * Inactive dots are smaller (6px) and lighter.
 *
 * @example
 * <OnboardingProgressDots currentSlide={0} totalSlides={3} theme="fuchsia" />
 */
export const OnboardingProgressDots = ({
  currentSlide,
  totalSlides,
  theme,
}: OnboardingProgressDotsProps) => {
  return (
    <div className="onboarding-progress-dots">
      {Array.from({ length: totalSlides }).map((_, index) => (
        <div
          key={index}
          className={`onboarding-progress-dots__dot ${
            index === currentSlide
              ? `onboarding-progress-dots__dot--active onboarding-progress-dots__dot--${theme}-active`
              : `onboarding-progress-dots__dot--${theme}-inactive`
          }`}
        />
      ))}
    </div>
  )
}
